import React from 'react';
import { useSelector } from 'react-redux';
import RichTextEditor from '../../common/RichTextEditor.jsx';
import { useSetWidgetAttribute } from '../hooks/useSetWidgetAttribute.js';
import styles from './WidgetInfoSettings.module.scss';
import CommonField from './ag_chart/components/CommonField.jsx';

function WidgetInfoSettings({widgetId}) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const widgetInfo = useSelector(state => state.dashboard.widgets[widgetId].settings?.widgetInfo);

    return (
        <fieldset className="mb-1">
            <CommonField label={I18n.t('widget_info')}>
                <RichTextEditor
                    id={StringHelper.random()}
                    wordLimit={0}
                    value={widgetInfo}
                    updateAnswer={(val) => setAttribute("settings.widgetInfo", val)}
                    className={styles['widget-info-settings-editor']}
                />
            </CommonField>
        </fieldset>
    )
}

export default WidgetInfoSettings;